var isMobileDevice = function () { return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent); };
var isTabletDevice = function () { return /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(navigator.userAgent); };
var DeviceType;
(function (DeviceType) {
    DeviceType["Smartphone"] = "Smartphone";
    DeviceType["Tablet"] = "Tablet";
    DeviceType["Desktop"] = "Desktop";
})(DeviceType || (DeviceType = {}));
var getDeviceType = function () {
    if (isMobileDevice())
        return DeviceType.Smartphone;
    if (isTabletDevice())
        return DeviceType.Tablet;
    return DeviceType.Desktop;
};

export { DeviceType, getDeviceType, isMobileDevice, isTabletDevice };
//# sourceMappingURL=index.es.js.map
